var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"amap-wrapper"},[_c('div',{staticStyle:{"width":"100vw","height":"100vh"},attrs:{"id":"amapContainer"}})])])
}]

export { render, staticRenderFns }